/* eslint-disable react/prop-types */
import { Component } from "react";
import { withRouter } from "react-router-dom";
import Constants from "../utilities/Constants";

class LoginHandler extends Component {

  // Verifies if the user has the credentials to be logged in
  // If he does he is re-directed to the configuration page
  // If he doesn't he is re-directed to the login page
  isUserLoggedIn = () => {
    if (sessionStorage.auth === Constants.AUTH_STR) {
      this.props.history.push({ pathname: "/config" });
    } else {
      this.props.history.push({ pathname: "/login" });
    }
  }

  // ----------------- Lifecycle Methods ----------------
  componentDidMount() {
    this.isUserLoggedIn();
  }

  render() {
    return (
      false
    );
  }

}

export default withRouter(LoginHandler);
